// extracted by mini-css-extract-plugin
export default {"fr-view":"MenuItem_fr-view__n89AV","container":"MenuItem_container__jModb","isActive":"MenuItem_isActive__xxCPG","icon":"MenuItem_icon__fTBKa"};